export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay" />

      <div className="hero-content">
        <h1 className="hero-title">Your Premier Destination</h1>
        <p>Welcome to Revived Hair Co.</p>
        <p>Professional haircuts, beard trims, and braiding services in the DMV.</p>
      </div>

      {/* Scroll down arrow */}
      <div
        className="scroll-down"
        onClick={() =>
          window.scrollTo({ top: window.innerHeight, behavior: "smooth" })
        }
      >
        <span></span>
      </div>
    </section>
  );
}
